export const initialState = {
    isAuthenticated: false,
    isConsented: undefined,
    isEdeliveryConsented: undefined,
    isLoading: true,
    isRegisteredUser: undefined,
    isPrimary: null,
    isError: {
        msg: '',
        error: false,
        httpErrorCode: ''
    },
    currentClientData: {},
    activeActions: [],
    confidenceScore: [],
    pastEngagements: false,
    cookieEnv: '',
    colorCookieEnv: '',
    documents: {},
    hasDocuments: false,
    archivedGroupSummary: null,
    planningGroup: null,
    pinRecievedCoClientData: null,
    prospStatuses: [],
    consentPreselect: {},
    educationModal: false,
    educationContinue: false,
    releasedFinancialPlan: false,
    releasedStrategyComparison: false,
    releasedSelectedStrategy: false,
    ricmPlanClicked: false,
    activeInvite: false,
    ssoData: undefined,
    ssoDataError: false,
    trpUserData: {},
    kycData: null,
    rtqData: null,
    clientPreferences: null,
    advisorClientData: {},
    financialAccounts: null,
    hasPartner: false,
    numberOfClients: undefined,
    rasActiveClient: null,
    apiKey: '',
    userEntitlements: undefined,
    engagementStatus: {
        status: null,
        effectiveDate: ''
    },
    reenroll: false,
    territoryName: '',
    tType: '',
    parentTerritory: '',
    employeeName: '',
    employeeRole: '',
    employeePhone: '',
    employeeEmail: '',
    schedulingLink: '',
    timeTradeFailure: false,
    adviceQuestionnaireLink: '',
    lastProspSection: null,
    message: false,
    hasEnteredPin: false,
    userStatus: null,
    userStatusFailure: false,
    loadProspectusData: false,
    apptDataLoading: true,
    invitations: {},
    pendingInvite: null,
    showYodleeModal: true,
    yodleeResponse: {
        lastRefreshDate: null,
        institutionName: null,
        yodleeErrorStatus: null
    },
};

export const UserReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ACTION_SERVICE':
            return {
                ...state,
                activeActions: action.activeActions
            };
        case 'AUTH_INITIALIZING':
            if ((
                action.apiKey === state.apiKey
                && action.isRegisteredUser === state.isRegisteredUser
                && action.trpUserData === state.trpUserData
                && action.isLoading === state.isLoading)
                || (state.isRegisteredUser === true
                    && action.isRegisteredUser === false
                    && action.trpUserData !== state.trpUserData)) {
                return state;
            }
            return {
                ...state,
                isAuthenticated: action.isAuthenticated,
                cookieEnv: action.cookieEnv,
                colorCookieEnv: action.colorCookieEnv,
                isLoading: action.isLoading,
                trpUserData: action.trpUserData,
                apiKey: action.apiKey,
                isRegisteredUser: action.isRegisteredUser,
                userEntitlements: action.userEntitlements
            };
        case 'AUTH_CONSENT_STATUS':
            return {
                ...state,
                isLoading: action.isLoading,
                isConsented: action.isConsented,
                isPrimary: action.isPrimary,
                isCustomerWebView: action.isCustomerWebView,
                numberOfClients: action.numberOfClients,
                engagementStatus: action.engagementStatus,
                lastCompletedSection: action.lastCompletedSection,
                isEdeliveryConsented: action.isEdeliveryConsented,
                currentClientData: action.currentClientData,
                isAdvisorLed: action.isAdvisorLed,
                consentPreselect: action.consentPreselect,
                documents: action.documents,
                hasDocuments: action.hasDocuments,
                confidenceScoreData: action.confidenceScoreData,
                pastEngagements: action.pastEngagements,
                rasActiveClient: action.rasActiveClient,
                trpUserData: action.trpUserData,
                archivedGroupSummary: action.archivedGroupSummary,
                planningGroup: action.planningGroup,
                hasEnteredPin: action.hasEnteredPin,
                activeInvite: action.activeInvite,
                pendingInvite: action.pendingInvite,
                prospStatuses: action.prospStatuses
            };
        case 'AVAILABLE_DOCUMENTS':
            return {
                ...state,
                releasedFinancialPlan: action.releasedFinancialPlan,
                releasedStrategyComparison: action.releasedStrategyComparison,
                releasedSelectedStrategy: action.releasedSelectedStrategy
            };
        case 'ENTERED_PIN_CO_CLIENT':
            return {
                ...state,
                hasEnteredPin: action.hasEnteredPin,
                pinRecievedCoClientData: action.pinRecievedCoClientData,
                engagementType: action.engagementType,
                isPrimary: action.isPrimary
            };
        case 'EDUCATION_CONTINUE':
            return {
                ...state,
                educationContinue: action.educationContinue
            };
        case 'KYC_RESPONSE':
            return {
                ...state,
                kycData: action.kycData
            };
        case 'RTQ_RESPONSE':
            return {
                ...state,
                rtqData: action.rtqData
            };
        case 'FINANCIAL_ACCOUNTS':
            return {
                ...state,
                financialAccounts: action.financialAccounts,
                isLoading: action.isLoading
            };
        case 'CLIENT_DATA':
            return {
                ...state,
                currentClientData: action.currentClientData,
                planningGroup: action.planningGroup,
                engagementStatus: action.engagementStatus,
            };
        case 'CLIENT_PREFERENCES_RESPONSE':
            return {
                ...state,
                clientPreferences: action.clientPreferences,
                isLoading: action.isLoading
            };
        case 'CLIENT_USER_STATUS_RESPONSE':
            return {
                ...state,
                userStatus: action.userStatus,
            };
        case 'CLIENT_USER_STATUS_FAILURE':
            return {
                ...state,
                userStatusFailure: action.userStatusFailure
            };
        case 'LOAD_PROSPECTUS_DATA':
            return {
                ...state,
                loadProspectusData: action.loadProspectusData
            };
        case 'ADVISOR_CLIENT_DATA':
            return {
                ...state,
                advisorClientData: action.advisorClientData,
            };
        case 'SELECTED_RELEASE_REPORTS':
            return {
                ...state,
                selectedReleaseReports: action.selectedReleaseReports
            };
        case 'HAS_PARTNER':
            return {
                ...state,
                hasPartner: action.hasPartner
            };
        case 'PROSP_STATUSES':
            return {
                ...state,
                prospStatuses: action.prospStatuses
            };
        case 'PROSP_COMPL_SEC':
            return {
                ...state,
                lastProspSection: action.lastProspSection
            };
        case 'CONSENT_UPDATED':
            return {
                ...state,
                isConsented: action.isConsented
            };
        case 'E_DELIVERY_UPDATED':
            return {
                ...state,
                isEdeliveryConsented: action.isEdeliveryConsented
            };
        case 'RICM_PLAN_CLICK':
            return {
               ...state,
                ricmPlanClicked: action.ricmPlanClicked
            };
        case 'UPDATE_REENROLL_STATUS':
            return {
                ...state,
                reenroll: action.reenroll
            };
        case 'SSO_DATA':
            return {
                ...state,
                ssoDataError: action.ssoDataError,
                ssoData: action.ssoData
            };
        case 'SSO_DATA_FAILURE':
            return {
                ...state,
                ssoDataError: action.ssoDataError
            };
        case 'TIME_TRADE_FAILURE':
            return {
                ...state,
                timeTradeFailure: action.timeTradeFailure,
                apptDataLoading: action.appDataLoading,
                isLoading: action.isLoading,
            };
        case 'TIME_TRADE_DATA':
            return {
                ...state,
                territoryName: action.territoryName,
                tType: action.tType,
                parentTerritory: action.parentTerritory,
                employeeName: action.employeeName,
                employeeRole: action.employeeRole,
                employeePhone: action.employeePhone,
                employeeEmail: action.employeeEmail,
                schedulingLink: action.schedulingLink,
                adviceQuestionnaireLink: action.adviceQuestionnaireLink
            };
        case 'APPOINTMENT_DATA':
            return {
                ...state,
                invitations: action.invitations,
                isLoading: action.isLoading,
                apptDataLoading: action.apptDataLoading
            };
        case 'YODLEE_MODAL':
            return {
                ...state,
                showYodleeModal: action.showYodleeModal
            };
        case 'YODLEE_RESPONSE':
            return {
                ...state,
                yodleeResponse: {
                    lastRefreshDate: action.lastRefreshDate,
                    institutionName: action.institutionName,
                    yodleeErrorStatus: action.errorStatus
                }
            };
        case 'AUTH_FAILURE':
            return {
                ...state,
                isLoading: action.isLoading,
                isError: {
                    httpErrorCode: action.error,
                    msg: action.error.message,
                    error: true,
                    errorBody: action.error
                }
            };
        case 'LOADING':
            return {
                ...state,
                isLoading: action.isLoading
            };
        default:
            return state;
    }
};
